import { render, staticRenderFns } from "./vue-verify-code.vue?vue&type=template&id=726bca37&scoped=true&"
import script from "./vue-verify-code.vue?vue&type=script&lang=js&"
export * from "./vue-verify-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bca37",
  null
  
)

export default component.exports